enum GNWP_SOURCES {
    CASHIER = 'cashier',
    CONTACT_US = 'contact_us',
    MEMBERSHIP = 'membership',
    FORGOT_PASSWORD = 'forgot_password',
    FORGOT_USERNAME = 'forgot_username',
    MY_ACCOUNT = 'my_account',
    OMG = 'omg',
    SPORT = 'sport',
    RICH = 'rich',
    PENDING_LOGIN = 'pending_login',
    PENDING_PLAY = 'pending_play',
    DOCUMENT_UPLOAD = 'upload_document',
    HELP = 'help',
    PENDING_APP = 'pending_app',
    POKER = 'poker',
    LIVE_CHAT = 'live_chat'
}

export {GNWP_SOURCES};
